import { PaytrieAPI } from '@paytrie/client'

import {
  TransactionType,
  TransactionValue,
} from '@/reducers/transactionReducer'
import { NetworkValue, StableCoinValue } from '@/utils/currencies'

/**
 * Prices the settled order again with the logged-in user's referral credit
 * applied. The API needs the bearer token for this, which the client attaches.
 */
export const getReferralQuote = async ({
  transactionType,
  stableCoin,
  network,
  payAmount,
}: {
  transactionType: TransactionValue
  stableCoin: StableCoinValue
  network: NetworkValue
  payAmount: number
}): Promise<PaytrieAPI.Quote> => {
  const isBuy = transactionType === TransactionType.BUY
  const networkSymbol =
    `${stableCoin}-${network}` as PaytrieAPI.GetQuotesRightSideLabel
  const res = await PaytrieAPI.getQuotes({
    leftSideLabel: isBuy ? 'CAD' : networkSymbol,
    rightSideLabel: isBuy ? networkSymbol : 'CAD',
    leftSideValue: payAmount,
    useReferral: true,
  })
  if (res.status !== 200 || !res.data.data) {
    throw new Error('Referral quote request failed')
  }
  return res.data.data
}
